import { render, staticRenderFns } from "./related-products.vue?vue&type=template&id=46221bf0&"
import script from "./related-products.vue?vue&type=script&lang=js&"
export * from "./related-products.vue?vue&type=script&lang=js&"
import style0 from "./related-products.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports